/**
 * this service is private and meant to be used by ParamBaseDataInputMenuMixin only!
 */
import ParamsService from '../../../../../utils/ParamsService';
import {
	EXTERNAL_SOURCE_TAB_KEY,
	REFRESH_DATA,
	SET_VALUE_FROM_EXTERNAL_SOURCE,
	UPDATE_SEARCH_STRING,
} from '../../../../DataInput/DataInputMenu/helpers/data-input-menu.const';
import api from '@/api';
import pagination from '@/api/pagination';

// helper methods of service

// methods exported by service

const addExternalDataInputListeners = function () {
	const listeners = {
		[REFRESH_DATA]: this.refreshData,
		[SET_VALUE_FROM_EXTERNAL_SOURCE]: this.updateExternalLocalValue,
		'end-intersect': this.endIntersect,
		[UPDATE_SEARCH_STRING]: (searchString) => {
			this.$data._search = searchString;
		},
	};
	Object.entries(listeners).forEach(([key, method]) => this.addDataInputMenuListener(key, method));
};

const seeMore = function () {
	this.$data._page++;
	// this.hasMoreData = false;
	this._getDataOnDemand();
};

const addExternalTabItem = function () {
	const fieldName = this.param.name ?? 'fieldName';
	this.addTabItem(EXTERNAL_SOURCE_TAB_KEY, fieldName, true);
};

const setExternalDataInputMenuProps = function () {
	Object.entries(this.externalDataInputMenuProps).forEach(([key, value]) => this.setDataInputMenuProp(key, value));
};

const retrieveData = async function () {
	const { id: nodeId, widgetFieldId, user_schema_mappings_source_field_uuid, credentials, overrideParamsMap, params_map } = this.node;
	// widgetFieldId is for retrieving the options for the search required params.
	// TODO - or maybe not todo,
	// create param dispatcher for widgets params so this wouldn't be here and wouldn't be coupled together

	if (!this.hasExternalSource || !this.needGetOptionsForAction || (!this.param.channelId && this.cantGetOptionsForAction)) {
		return;
	}
	this.$data._loading = true;
	this.$data._errorMessage = null;
	const actionSource = ParamsService.extractSourceAction(this.param);
	let handler;
	if (this.param.channelId) {
		handler = () =>
			api.notifications.getChannelParamOptions({
				channelId: this.param.channelId,
				source: actionSource,
				term: this.searchString,
				param_key: this.param.key,
				page: this.$data._page,
				retrievalId: this.$data._retrievalId,
			});
	} else if (this.userSchemaMappingId) {
		handler = () =>
			api.getOptionsForWidget(
				user_schema_mappings_source_field_uuid,
				actionSource,
				this.searchString,
				this.param.key,
				this.$data._page,
				this.$data._retrievalId,
				this.workflowVersion.id,
				credentials,
				overrideParamsMap ? params_map : null
			);
	} else if (this.placementContextId) {
		handler = () =>
			api.getOptionsForContextualData(
				this.placementContextId,
				this.paramsMap,
				credentials,
				actionSource,
				this.searchString,
				null,
				this.page,
				this.retrievalId
			);
	} else {
		handler = () =>
			api.getOptionsForAction(
				nodeId,
				actionSource,
				this.searchString,
				this.param.key,
				this.$data._page,
				this.$data._retrievalId,
				widgetFieldId,
				this.param.multiItemId
			);
	}
	const ret = await handler();
	this.$data._loading = false;
	const response = pagination.consolidateGetOptionsForActionResponse(ret);
	if (response.errorMessage) {
		this.$data._hasMoreData = false;
		this.$data._errorMessage = response.errorMessage;
		return;
	}
	this.$data._hasMoreData = response.hasMoreData;
	this.$data._retrievalId = response.retrievalId;
	if (this.$data._page === 1) {
		this.$set(this.$data, '_items', response.results);
	} else {
		this.$data._items.push(...response.results);
	}
};

const onSearchStringUpdate = function () {
	this.resetState();
	this._getData(); // debounced version
};

const ExternalSourceMixinService = {
	addExternalDataInputListeners,
	seeMore,
	retrieveData,
	addExternalTabItem,
	setExternalDataInputMenuProps,
	onSearchStringUpdate,
};

export default ExternalSourceMixinService;
